import { render, staticRenderFns } from "./BillingList.vue?vue&type=template&id=8f99b0d4"
import script from "./BillingList.vue?vue&type=script&lang=js"
export * from "./BillingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports